import * as d3 from 'd3';
import Api from '../Api.js';
import Thinker from "../components/Thinker";

const LinePercentage = function (options) {
    function render() {
        const container = $(options.container);

        const margin = {top: 50, right: 90, bottom: 60, left: 90},
            width = container.width() - margin.left - margin.right,
            height = 500 - margin.top - margin.bottom;

        const curtainDelay = 750,
            curtainDuration = 2000;

        const x = d3.scaleLinear()
            .range([0, width]);

        const y = d3.scaleLinear()
            .range([height, 0]);

        const xAxis = d3.axisBottom()
            .scale(x)
            .tickSize(10);

        const yAxis = d3.axisLeft()
            .scale(y);

        const line = d3.line()
            .x(function (d) {
                return x(d.x);
            })
            .y(function (d) {
                return y(d.y);
            });

        const area = d3.area()
            .x(function (d) {
                return x(d.x);
            })
            .y0(height)
            .y1(function (d) {
                return y(d.y);
            });


        const svg = d3.select(options.svg)
            .attr('width', width + margin.left + margin.right)
            .attr('height', height + margin.top + margin.bottom)
            .append('g')
            .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

        const div = d3.select('body')
            .append('div')
            .attr('class', 'graph-tip')
            .style('opacity', 0);

        const url = $(options.container).data('url');
        const ylabel = $(options.container).data('ylabel');
        const form = $(options.container).find('form').aeroSerialize();

        $(options.container).find('.loading').show();

        Api.send(url, form).done(function (data) {
            Thinker.end($(options.container));
            $(options.container).find('.loading').hide();
            // clear svg
            svg.selectAll('*').remove();

            if (!data.length) {
                // no results
                svg.append('rect')
                    .attr('x', -1 * width)
                    .attr('y', -1 * height)
                    .attr('height', height)
                    .attr('width', width)
                    .attr('class', 'curtain')
                    .attr('transform', 'rotate(180)')
                    .style('fill', '#f1f1f1');
                svg.append('text')
                    .html('No activity found for this guide.')
                    .attr('y', height / 2)
                    .attr('x', width / 2)
                    .style('text-anchor', 'middle')
                    .style('font-size', '16px');
                return;
            }

            x.domain([data[0].x, data[data.length - 1].x]);
            y.domain([0, d3.max(data, function (d) {
                return d.y;
            })]);

            svg.append('path')
                .datum(data)
                .attr('class', 'area')
                .attr('d', area);

            svg.append('path')
                .datum(data)
                .attr('class', 'line')
                .attr('d', line);

            const g = svg.selectAll()
                .data(data)
                .enter()
                .append('g');

            g.append('circle')
                .style('opacity', 0)
                .attr('class', 'point')
                .attr('r', 5.5)
                .attr('cx', function (d) {
                    return x(d.x);
                })
                .attr('cy', function (d) {
                    return y(d.y);
                })
                .transition()
                .delay(function (d, i) {
                    return curtainDuration - i * 20 + curtainDelay;
                })
                .duration(500)
                .style('opacity', 1);

            //The horizontal dashed line that appears when a circle marker is moused over
            g.append('line')
                .attr('class', 'x')
                //.attr('id', 'dashedLine')
                .style('stroke', 'steelblue')
                .style('stroke-dasharray', '3,3')
                .style('opacity', 0)
                .attr('x1', function (d) {
                    return x(d.x);
                })
                .attr('y1', function (d) {
                    return y(d.y);
                })
                .attr('x2', function (d) {
                    return '0' || x(d3.min(d.x));
                })
                .attr('y2', function (d) {
                    return y(d.y);
                });

            //The vertical dashed line that appears when a circle marker is moused over
            g.append('line')
                .attr('class', 'y')
                //.attr('id', 'dashedLine')
                .style('stroke', 'steelblue')
                .style('stroke-dasharray', '3,3')
                .style('opacity', 0)
                .attr('x1', function (d) {
                    return x(d.x);
                })
                .attr('y1', function (d) {
                    return y(d.y);
                })
                .attr('x2', function (d) {
                    return x(d.x);
                })
                .attr('y2', height);

            // tooltip
            g.selectAll('circle').on('mouseover', function (event, d) {
                div.transition()
                    .duration(200)
                    .style('opacity', 0.9);
                div.html(`Step ${d.x}<br>${d.y}%`)
                    .style('left', (event.pageX - 20) + 'px')
                    .style('top', (event.pageY + 6) + 'px');
                //selects the horizontal dashed line in the group
                d3.select(this.nextElementSibling).transition()
                    .duration(200)
                    .style('opacity', 0.9);
                //selects the vertical dashed line in the group
                d3.select(this.nextElementSibling.nextElementSibling).transition()
                    .duration(200)
                    .style("opacity", 0.9);
            })
                .on('mouseout', function () {
                    div.transition()
                        .duration(500)
                        .style('opacity', 0);

                    d3.select(this.nextElementSibling).transition()
                        .duration(500)
                        .style('opacity', 0);

                    d3.select(this.nextElementSibling.nextElementSibling).transition()
                        .duration(500)
                        .style('opacity', 0);
                });

            svg.append('g')
                .attr('class', 'x axis')
                .attr('transform', 'translate(0 , ' + height + ')')
                .call(xAxis);

            svg.append('g')
                .attr('class', 'y axis')
                .call(yAxis);

            svg.append('text')
                .attr('y', 30 - margin.left)
                .attr('x', 50 - (height / 2))
                .attr('transform', 'rotate(-90)')
                .style('text-anchor', 'end')
                .style('font-size', '16px')
                .text(ylabel);

            // curtain
            svg.append('rect')
                .attr('x', -1 * width)
                .attr('y', -1 * height)
                .attr('height', height)
                .attr('width', width)
                .attr('class', 'curtain')
                .attr('transform', 'rotate(180)')
                .style('fill', '#ffffff')
                .transition()
                .delay(curtainDelay)
                .duration(curtainDuration)
                .ease(d3.easeLinear)
                .attr('width', 0);
        });
    }

    $(options.container).find('form input').on('change', function () {
        $(options.svg).empty();
        render();
    });

    setTimeout(function () {
        Thinker.begin($(options.container));
        render();
    }, 100);

    function update() {
        $(options.svg).empty();
        setTimeout(function () {
            Thinker.begin($(options.container));
            render();
        }, 500);
    }

    $('body').on('click', '.hamburger a', function () {
        $(options.container).trigger('update');
    });

    $(options.container).on('update', function () {
        update();
    });
};

export default LinePercentage;
